module.exports = __webpack_public_path__ + "media/category_icons/Geriatrics-ba08faf3.svg";